import Avatar from "../layout/Avatar";
import { WhatsappGroupsHook } from "../../hooks/useWhatsappGroups";
import { formatListTime } from "../whatsapp/format";

// Só as linhas da lista — sem Card/busca/abas, que ficam no nível da
// página (mesmo card e mesma barra de abas do 1:1, ver Whatsapp.page.tsx).
function GroupListRows(props: { hook: WhatsappGroupsHook; myId: string }) {
  const { rows, selectedId, setSelectedId } = props.hook;

  return (
    <>
      {rows.map((g) => {
        const unread = g.unreadByUser?.[props.myId] || 0;
        return (
          <button
            key={g.id}
            onClick={() => setSelectedId(g.id)}
            className={`w-full text-left flex gap-2.5 p-2 rounded-15 mb-0.5 ${
              g.id === selectedId ? "bg-purple/10" : "hover:bg-white-dark"
            }`}
          >
            <Avatar avatar="" className="bg-gray-bluish w-9 h-9 flex-none" />
            <div className="flex-1 min-w-0">
              <div className="flex justify-between gap-2">
                <div className="font-bold text-xs text-primary truncate">{g.name}</div>
                <div className="flex items-center gap-1.5 flex-none">
                  {!!g.lastMessageAt && (
                    <span className="text-[9.5px] text-gray-dark tabular-nums">
                      {formatListTime(g.lastMessageAt)}
                    </span>
                  )}
                  {unread > 0 && (
                    <div className="bg-purple text-white text-[10px] font-bold rounded-full min-w-[17px] h-[17px] grid place-items-center px-1">
                      {unread}
                    </div>
                  )}
                </div>
              </div>
              <div className="text-[10px] text-gray-dark">
                {g.participants.length}{" "}
                {g.participants.length === 1 ? "participante" : "participantes"}
              </div>
              {!!g.lastMessageText && (
                <div className="text-[10.5px] text-gray-dark truncate mt-0.5">
                  {g.lastMessageText}
                </div>
              )}
            </div>
          </button>
        );
      })}
      {rows.length === 0 && (
        <div className="text-center text-xs text-gray-dark py-8">
          Nenhum grupo ainda. Grupos aparecem aqui assim que chegar a primeira mensagem, ou crie
          um novo.
        </div>
      )}
    </>
  );
}

export default GroupListRows;
